import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { IVTableColumn } from "../../_models/IVTableColumn";
import { VTableService } from "../../_services/v-table.service";
import './v-table-column-editor.component.scss';

@Component({
    selector: 'column-editor',
    template: require('./v-table-column-editor.component.html')
})
export class VTableColumnEditorComponent implements OnChanges {
    @Input() columns: IVTableColumn<any>[];
    @Output() columnsChange = new EventEmitter<IVTableColumn<any>[]>();

    storageKey: string;

    constructor(
        private readonly vTableService: VTableService) { }

    ngOnChanges(): void {
        this.storageKey = this.vTableService.getTableId(this.columns);
    }
    
    onColumnChecked(column: IVTableColumn<any>, checked: boolean): void {
        column.header.hidden = !column.header.hidden;
        this.saveUserColumnPreferences();
    }

    //--

    private saveUserColumnPreferences(): void {
        window.localStorage.setItem(this.storageKey, JSON.stringify(this.columns));
    }
}
